"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showIf = showIf;
function showIf(term, elem, elseElem) {
    if (term) {
        return elem();
    } else {
        return elseElem ? elseElem() : null;
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-storage-nav@0.0.16@@alicd/crui-storage-nav/lib/util.js
// module id = 672
// module chunks = 0